import {ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {IconProps} from "../../common/icon/Icon";
import React from "react";


interface MobileMenuListItemProps {
    title: string;
    icon: React.ComponentType<IconProps>;
    hidden?: boolean;
    onClick: () => void;
}

export default function MobileMenuListItem(props: Readonly<MobileMenuListItemProps>) {
    const {title, icon: Icon, hidden = false, onClick} = props;

    if (hidden) {
        return null;
    }

    return (
        <ListItem disablePadding style={{marginBottom: 0}}>
            <ListItemButton onClick={onClick}>
                <ListItemIcon>
                    <Icon />
                </ListItemIcon>
                <ListItemText primary={title}/>
            </ListItemButton>
        </ListItem>
    );
}